import { useState, useMemo } from "react";
import { css } from "@emotion/react";

import { MediaModal } from "../molecules";

type Props = {
  title: string;
};

const mizugiDeltaPositions = [
  { deltaTop: 15, deltaLeft: 0, vertical: false },
  { deltaTop: 15, deltaLeft: 0, vertical: false },
  { deltaTop: 20, deltaLeft: 0, vertical: false },
  { deltaTop: 15, deltaLeft: 0, vertical: false },
  { deltaTop: 15, deltaLeft: 0, vertical: false },
  { deltaTop: 15, deltaLeft: 0, vertical: false },
  { deltaTop: 0, deltaLeft: 0, vertical: true },
  { deltaTop: 10, deltaLeft: 0, vertical: false },
  { deltaTop: 20, deltaLeft: 0, vertical: false },
  { deltaTop: 0, deltaLeft: 0, vertical: true },
  { deltaTop: 25, deltaLeft: 0, vertical: false },
  { deltaTop: 0, deltaLeft: 0, vertical: true },
];

const kosupureDeltaPositions = [
  { deltaTop: 15, deltaLeft: 0, vertical: false },
  { deltaTop: 0, deltaLeft: 0, vertical: true },
  { deltaTop: 0, deltaLeft: 0, vertical: true },
  { deltaTop: 0, deltaLeft: 15, vertical: true },
  { deltaTop: 15, deltaLeft: 0, vertical: false },
  { deltaTop: 15, deltaLeft: 0, vertical: false },
  { deltaTop: 15, deltaLeft: 0, vertical: false },
  { deltaTop: 10, deltaLeft: 0, vertical: false },
  { deltaTop: 0, deltaLeft: 0, vertical: true },
  { deltaTop: 0, deltaLeft: 0, vertical: false },
  { deltaTop: 0, deltaLeft: 0, vertical: true },
  { deltaTop: 0, deltaLeft: 0, vertical: true },
];

const Special: React.FC<Props> = ({ title }) => {
  const [selectedPath, setSelectedPath] = useState<string | undefined>(
    undefined,
  );

  const modalProps = useMemo(
    () => ({
      type: "image" as const,
      id: selectedPath,
      onClose: () => setSelectedPath(undefined),
      getMediaArgs: {},
    }),
    [selectedPath],
  );

  return (
    <div id="special" css={mainStyle}>
      <div css={contentsWrapper}>
        <div css={upperTitleWrapperStyle}>
          <div css={borderStyle}></div>
          <div css={titleStyle}>{title}</div>
          <div css={borderStyle}></div>
        </div>
        <img
          src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/mizugi.png"}
          css={titleImgStyle(60, 35)}
        />
        <div css={[photosWrapperStyle, marginTopStyle(0)]}>
          {mizugiDeltaPositions.map((positions, i) => (
            <div
              onClick={() =>
                setSelectedPath(
                  process.env.REACT_APP_ASSET_BASE_PATH +
                    `/img/mizugi/${i + 1}.jpg`,
                )
              }
              css={[photoWrapperStyle, marginTopStyle(15)]}
              key={"mizugi" + i}
            >
              <img
                src={
                  process.env.REACT_APP_ASSET_BASE_PATH +
                  `/img/mizugi/${i + 1}.jpg`
                }
                css={photoStyle({ ...positions })}
              />
            </div>
          ))}
        </div>
        <img
          src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/kosupure.png"}
          css={[titleImgStyle(80, 50), marginTopStyle(20)]}
        />
        <div css={[photosWrapperStyle, marginTopStyle(0)]}>
          {kosupureDeltaPositions.map((positions, i) => (
            <div
              onClick={() =>
                setSelectedPath(
                  process.env.REACT_APP_ASSET_BASE_PATH +
                    `/img/kosupure/${i + 1}.jpg`,
                )
              }
              css={[photoWrapperStyle, marginTopStyle(15)]}
              key={"kosupure" + i}
            >
              <img
                src={
                  process.env.REACT_APP_ASSET_BASE_PATH +
                  `/img/kosupure/${i + 1}.jpg`
                }
                css={photoStyle({ ...positions })}
              />
            </div>
          ))}
        </div>
      </div>
      <MediaModal {...modalProps} />
    </div>
  );
};

const spSize = 768;

const mainStyle = css`
  width: 100%;
`;

const contentsWrapper = css`
  width: 100%;
  margin-bottom: 40px;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const upperTitleWrapperStyle = css`
  width: 85%;
  max-width: 1125px;
  display: flex;
  align-items: center;
  padding: 30px;

  @media (max-width: ${spSize}px) {
    padding: 10px 20px;
    padding-bottom: 10px !important;
  }
`;

const borderStyle = css`
  height: 3px;
  background-color: white;
  flex-grow: 1;
`;

const titleStyle = css`
  padding: 0 15px;
  font-family: MyFont;
  font-size: 23px;
  font-weight: 500;
  line-height: 100%;

  @media (max-width: ${spSize}px) {
    font-size: 18px;
  }
`;

const titleImgStyle = (pcWidth: number, spWidth: number) => css`
  width: ${pcWidth}px;
  height: auto;

  @media (max-width: ${spSize}px) {
    width: ${spWidth}px;
  }
`;

const marginTopStyle = (num: number, spNum?: number) => css`
  margin-top: ${num}px;

  @media (max-width: ${spSize}px) {
    margin-top: ${spNum ?? num}px;
  }
`;

const photosWrapperStyle = css`
  max-width: 1125px;
  width: 85%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @media (max-width: 500px) {
    flex-wrap: nowrap;
    flex-direction: column;
    align-items: center;
  }
`;

const photoWrapperStyle = css`
  position: relative;
  width: 250px;
  height: 250px;
  overflow: hidden;

  @media (max-width: ${spSize}px) {
    width: 200px;
    height: 200px;
  }

  &:hover {
    cursor: pointer;
  }
`;

const photoStyle = ({
  deltaTop,
  deltaLeft,
  vertical,
}: {
  deltaTop: number;
  deltaLeft: number;
  vertical: boolean;
}) => css`
  position: absolute;
  top: ${50 + (deltaTop ?? 0)}%;
  left: ${50 + (deltaLeft ?? 0)}%;
  transform: translate(-50%, -50%);
  ${vertical
    ? `
        width: auto;
        height: 100%;
      `
    : `
        width: 100%;
        height: auto;
      `}
`;

export default Special;
